import axios from 'axios';

export const urlPreviewTypeMap = {
    DEFAULT: 'DEFAULT',
    INSTAGRAM_POST: 'INSTAGRAM_POST'
};

export type URLPreviewType = keyof typeof urlPreviewTypeMap;

export interface BaseURLPreviewData {
    type: URLPreviewType;
    data: {
        title?: string;
        description?: string;
        favicon?: string;
        url?: string;
        image?: string;
    };
}

export interface InstagramPostURLPreviewData extends BaseURLPreviewData {
    type: 'INSTAGRAM_POST';
    data: {
        title?: string;
        description?: string;
        favicon?: string;
        url?: string;
        image?: string;
        caption: string;
    };
}

export type URLPreviewData = BaseURLPreviewData | InstagramPostURLPreviewData;

interface URLPreviewResponse {
    previews: URLPreviewData[];
}

export function isInstagramPostPreviewData(previewData: URLPreviewData): previewData is InstagramPostURLPreviewData {
    return previewData.type === 'INSTAGRAM_POST';
}

export async function getUrlPreviews(urls: string[]): Promise<URLPreviewData[]> {
    const url = `https://grispi.social/api/url-preview?urls=${urls.join(',')}`;
    const response = await axios.get<URLPreviewResponse>(url);

    return response.data.previews;
}
